import type { SearchResponse } from '@algolia/client-search';
import algoliasearch from 'algoliasearch';
import { algoliaConfigProps, algoliaDefaultConfig } from 'utilities/helpers/config.algolia.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { getWindow } from 'utilities/window.js';

export type AlgoliaResponseObject = {
  objectID: string;
  ranking: number;
  subtitle?: string;
  region?: string;
  subtype?: string;
  title: string;
  type: string;
  url: string;
  weighting: number;
};

export type AlgoliaSearchResultType = SearchResponse<AlgoliaResponseObject>;

export const algoliaSearchIndex = async (query: string): Promise<AlgoliaSearchResultType | void> => {
  try {
    const algoliaConfig: Required<algoliaConfigProps> = {
      ...algoliaDefaultConfig,
      ...getWindow()?.algoliaConfig,
    };

    const searchInit = algoliasearch(
      __ALGOLIA_APP_ID__ ?? '',
      __ALGOLIA_API_KEY__ ?? '',
    );

    const searchIndex = searchInit.initIndex(algoliaConfig.searchIndex);
    const searchResult: AlgoliaSearchResultType = await searchIndex.search(query, {
      hitsPerPage: algoliaConfig.hitsPerPage,
    });

    return searchResult;
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : String(e);
    messageLog.error('Unable to run Algolia Search', ['Algolia Search Index', errorMessage]);
  }
};
